import { debounce } from '../util/debounce';

type ProductImpressionData = {
  id: string;
  name: string;
  price: string | number;
  brand: string;
  category: string;
  position: number;
};

class Collection {
  private tempProducts = new Map<string, ProductImpressionData>();

  private pushToDataLayer = () => {
    if (!this.tempProducts.size) return;

    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    const event = {
      event: 'productsImpression',
      ecommerce: {
        impressions: Array.from(this.tempProducts.values()),
      },
    };

    window.dataLayer.push(event);
    this.tempProducts.clear();
  };

  private debounceFunc = debounce(this.pushToDataLayer, 3000);

  pushItem(productObject: ProductImpressionData) {
    const rawId: unknown = (productObject as any).id;
    const key = Array.isArray(rawId) ? String(rawId[0]) : String(rawId ?? '');

    if (!this.tempProducts.has(key)) {
      this.tempProducts.set(key, { ...productObject, id: key });
    }
    this.debounceFunc();
  }
}

const impressionCollection = new Collection();
export default impressionCollection;
